import React, { useState, useEffect } from "react";
import { Table, Input, Space, Button } from "antd";
import ordersApi from "Api/orders";
import chemicalType from "Types/chemicalType";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker2";
import statusType from "Types/statusType";

const ApprovedOrders = () => {
  const { data: approvedOrders, status } = ordersApi.useApproved();
  return (
    <Table
      title={ExcellPicker}
      loading={status === "loading"}
      dataSource={approvedOrders}
      columns={[
        {
          title: "تاریخ درخواست",
          dataIndex: "created",
          render: (created) =>
            `${new Date(created).toLocaleDateString("fa-IR")} - ${new Date(
              created
            ).toLocaleTimeString("fa-IR")}`,
        },
        {
          title: "درخواست دهنده",
          dataIndex: "user",
          render: (user) => `${user.name} ${user.family}`,
        },
        {
          title: "ماده درخواستی",
          dataIndex: "chemical",
          render(chemical: chemicalType) {
            return (
              <Link to={`/chemicals/addEdit/${chemical.id}`}>
                {chemical.enName}
              </Link>
            );
          },
        },
        {
          title: "مقدار درخواستی",
          dataIndex: "requestedAmount",
          render(amount, order) {
            return `${amount} ${order.chemical.unit?.name}`;
          },
        },
        {
          title: "مقدار موافقت شده",
          dataIndex: "agreedAmount",
          render(amount, order) {
            return `${amount} ${order.chemical.unit?.name}`;
          },
        },
        {
          title: "توضیحات",
          dataIndex: "statuses",
          render(statuses: statusType[]) {
            return (
              <Input.TextArea
                value={statuses[statuses.length - 1].description || ""}
              />
            );
          },
        },
      ]}
    />
  );
};

const ExcellPicker = () => {
  const [state, setState] = useState<any>({
    from: null,
    until: null,
  });
  return (
    <Space>
      <span>از</span>
      <DatePicker
        isGregorian={false}
        value={state.from}
        onChange={(value) => setState({ ...state, from: value })}
        timePicker={false}
      />
      <span>تا</span>
      <DatePicker
        isGregorian={false}
        value={state.until}
        onChange={(value) => setState({ ...state, until: value })}
        timePicker={false}
      />
      <Button
        disabled={!state.from || !state.until}
        onClick={() => {
          var xhr = new XMLHttpRequest();
          xhr.open("POST", "/api/excels/approvedOrders", true);
          xhr.responseType = "arraybuffer";
          xhr.onload = function () {
            if (this.status === 200) {
              var filename = "";
              var disposition = xhr.getResponseHeader("Content-Disposition");
              if (disposition && disposition.indexOf("attachment") !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1])
                  filename = matches[1].replace(/['"]/g, "");
              }
              var type = xhr.getResponseHeader("Content-Type");

              var blob;
              if (typeof File === "function") {
                try {
                  blob = new File([this.response], filename, {
                    type: type || undefined,
                  });
                } catch (e) {
                  /* Edge */
                }
              }
              if (typeof blob === "undefined") {
                blob = new Blob([this.response], { type: type || undefined });
              }

              if (typeof window.navigator.msSaveBlob !== "undefined") {
                // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                window.navigator.msSaveBlob(blob, filename);
              } else {
                var URL = window.URL || window.webkitURL;
                var downloadUrl = URL.createObjectURL(blob);

                if (filename) {
                  // use HTML5 a[download] attribute to specify filename
                  var a = document.createElement("a");
                  // safari doesn't support this yet
                  if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                  } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                  }
                } else {
                  window.location.href = downloadUrl;
                }
                setTimeout(function () {
                  URL.revokeObjectURL(downloadUrl);
                }, 100); // cleanup
              }
            }
          };
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(
            JSON.stringify({
              from: new Date(state.from),
              until: new Date(state.until),
            })
          );
        }}
      >
        دریافت گزارش
      </Button>
    </Space>
  );
};

export default ApprovedOrders;
